// Querys and Mutations
import {
    CREATE_CESSATION,
    GET_BY_EMPLOYEE,
    UPDATE_CESSATION,
    DELETE_CESSATION
} from '@/graphql/config/CessationEmployeesGraphql'

// models
import { CessationEmployeeForm, CessationEmployeeModel, CessationEmployeeWithPagination } from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class CessationEmployeeService {
    /**
     * Queries
     */
    async getByEmployee (employee_id: number, page: number, perPage: number): Promise<CessationEmployeeWithPagination> {
        const result = await apolloClient.query({
            query: GET_BY_EMPLOYEE,
            variables: {
                employee_id: employee_id,
                page: page,
                perPage: perPage
            }
        })
        const res = result.data.cessationEmployeesWithPagination
        return {
            objects: res.data,
            pagination: res.paginatorInfo
        }
    }

    /**
     * Mutations
     */
    async create (form: CessationEmployeeForm): Promise<CessationEmployeeModel> {
        const result = await apolloClient.mutate({
            mutation: CREATE_CESSATION,
            variables: {
                input: form
            }
        })
        return result.data.createCessationEmployee
    }

    async update (id: number, form: CessationEmployeeForm): Promise<CessationEmployeeModel> {
        const result = await apolloClient.mutate({
            mutation: UPDATE_CESSATION,
            variables: {
                input: form,
                id: id
            }
        })
        return result.data.updateCessationEmployee
    }

    async delete (id: number): Promise<CessationEmployeeModel> {
        const result = await apolloClient.mutate({
            mutation: DELETE_CESSATION,
            variables: {
                id: id
            }
        })
        return result.data.deleteCessationEmployee
    }
}

export default new CessationEmployeeService()
